<template>
    <div class="edit">
        <div v-if="step==1">
            <div class="title h_48">{{isEdit==true?'编辑商品':'添加商品'}}</div>
            <div class="edit-title">基本信息</div>
                <Form  :label-width="100">
                    <FormItem label="* 商品名：">
                        <Input  style="width:400px" v-model="mailCommodity.name" placeholder="商品名（必填）"/>
                    </FormItem>
                     <FormItem label="商品卖点：">
                        <Input  style="width:400px" v-model="mailCommodity.sellingPoint" placeholder="商品卖点"/>
                    </FormItem>
                    <FormItem label="分享描述：">
                        <Input  style="width:400px" v-model="mailCommodity.shareDesc" placeholder="分享描述"/>
                    </FormItem>
                    <FormItem label="* 商品图：">
                        <span style="color:red">* 第一张图片作为展示图片</span>
                        <div class="image-view">
                            <div class="image-list">
                                <div class="image-item" v-for="(item,index) in mailCommodity.images" :key="index">
                                    <div class="mask">
                                        <Icon type="md-eye" size="28" color="#FFFFFF" style="marginRight:5px" @click="ShowBigImage(item)"/>
                                        <Icon type="ios-trash" size="28" color="#FFFFFF" @click="DelGoodsImage(index)"/>
                                    </div>
                                    <img :src="item" alt="">
                                </div>
                            </div>
                             <cropper @childFun="childFun2" :data="cropper_data" ></cropper>
                            <!-- <Upload
                                :show-upload-list="false"  
                                :on-success="GoodsImageHandleSuccess"
                                :format="['jpg','jpeg','png']"
                                :max-size="2048"
                                multiple
                                type="drag"
                                :action="action"
                                :headers='{"Authorization":"Bearer "+token}'
                                >
                                
                                <div class="upload">
                                    <Icon type="md-add" size="38"/>
                                    <span>上传图片</span>
                                </div>
                            </Upload> -->
                        </div>
                         <!-- <span style="color:#666">推荐图片尺寸为4:3,像素为1200x900</span> -->
                    </FormItem>
                    <FormItem label='主要视频：'>
                        <Progress v-if="uploadVideoStatus" style="width:500px" :percent="uploadVideoPercent" :stroke-color="['#108ee9', '#87d068']" />
                        <div  class="video-view">
                            <video v-if="mailCommodity.video!=null" :src="mailCommodity.video" style="marginRight:20px" controls="controls" width="400" height="200">
                                您的浏览器不支持 video 标签。
                            </video>
                            <div style="height:200px;">
                                <Upload
                                    :show-upload-list="false"  
                                    :on-success="GoodsVideoSuccess"
                                    multiple
                                    type="drag"
                                    :action="videoAction"
                                    :on-progress="VideoProgress"
                                    :headers='{"Authorization":"Bearer "+token}'
                                >
                                    <div class="upload"  >
                                        <Icon type="md-add" size="38"/>
                                        <span v-if="mailCommodity.video!=null">重新上传</span>
                                        <span v-else>上传视频</span>
                                    </div>
                                </Upload>
                                <Button class="top40" @click="del_video" type="error">删除</Button>   
                            </div>
                           
                        </div>
                    </FormItem>
                    <FormItem label="* 商品品类：">
                        <Select  style="width:200px" v-model="mailCommodity.commodityCategory">
                            <Option v-for="item in goodsCategory" :value="item.guid" :key="item.guid">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="* 商品分组：">
                        <Select  style="width:200px"  v-model="mailCommodity.commodityGroup">
                            <Option v-for="item in goodsGroup" :value="item.guid" :key="item.guid">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Form>
            <!-- 商品规格 -->
            <div class="edit-title" style="marginBottom:20px">商品规格</div>
            <Form :label-width="100">
                <FormItem label="* 商品规格：">
                    <div class="goods-sp">
                        <div class="sp-item" v-for="(item,index) in spList" :key="index" @click="SpSelect(index)">
                            <Input v-model="item.specsName"/>
                            <div class="sp-image-view">
                                <img v-if='item.images!=null' width="80" height="80"  :src="item.images" alt/>
                                <Upload
                                    :show-upload-list="false"  
                                    :on-success="handleSuccessSpImage"
                                    :format="['jpg','jpeg','png']"
                                    :max-size="2048"
                                    multiple
                                    :action="action"
                                    :headers='{"Authorization":"Bearer "+token}'
                                    >
                                    <div class="sp-upload">
                                        <div v-if="item.images!=null">重新上传</div>
                                        <Icon type="md-add" size="24"/>
                                    </div>
                                </Upload>
                            </div>
                        </div>
                        <Button  type="primary" @click="AddSp">添加规格</Button>
                    </div>
                </FormItem>
                <FormItem label="* 规格明细：">
                    <!-- 规格表 -->
                    <Table :columns="spcolumns" :data="spList">
                        <template slot-scope="{ row,index }" slot="price">
                            <Input v-model="spList[index].price" type="number" @on-focus="spItemFocus(index)" @on-blur='spItemBlur'/>
                        </template>
                        <template slot-scope="{ row,index }" slot="stock">
                            <InputNumber :min="0" v-model="spList[index].stock"></InputNumber>
                        </template>
                        <template slot-scope="{ row,index }" slot="weight">
                            <Input   v-model="spList[index].weight" type="number"/>
                        </template>
                        <template slot-scope="{ row,index }" slot="specsCode">
                            <Input v-model="spList[index].specsCode" />
                        </template>
                        <template slot-scope="{ row,index }" slot="integral">
                            <InputNumber  :min="1" v-model="spList[index].integral"></InputNumber>
                        </template>
                        <template slot-scope="{row,index}" slot="display" >
                            <div  @click="changeSpFocus(index)">
                                <i-switch  @on-change="changeSpDisplay" v-model="spList[index].isDisplay"  :true-value="1" :false-value="0" />
                            </div>
                        </template>
                        <template slot-scope="{ row,index }" slot="operating">
                            <Button type="error" ghost @click="delSp(index)" v-if="row.isNew">删除</Button>
                            <span v-else>直接编辑</span>
                        </template>
                    </Table>
                </FormItem>
            </Form>
            <!-- 物流信息 -->
            <div class="edit-title" style="marginBottom:20px">物流信息</div>
            <Form  :label-width="100" style="marginBottom:70px">
                <FormItem label="* 快递运费：">
                    <div class="freight-view">
                            <RadioGroup v-model="mailCommodity.freightType" :vertical="true" @on-change="freightChange">
                            <div class="freight-item">
                                <Radio :label='1'/>
                                <span>统一邮费（元）：</span>
                                <Input  @on-blur='freighInputBlur'  v-model="mailCommodity.freightPrice"  :disabled="mailCommodity.freightType==2" placeholder="输入邮费单位（分）" style="width: 200px" />
                            </div>
                            <div style="height:20px"/>
                            <div class="freight-item">
                                <Radio :label='2'/>
                                    <span>邮费模板：</span>
                                <Select :disabled="mailCommodity.freightType==1" style="width:200px" v-model="mailCommodity.freightTypeGuid" @on-change="mailCommodity.freightType=2">
                                    <Option v-for="item in freightModel" :value="item.guid" :key="item.guid">{{ item.name }}</Option>
                                </Select>
                                <a href="/layout/goods/freight" style="marginLeft:20px">查看所有模板</a>
                                </div>
                            
                        
                        </RadioGroup>
                        
                    </div>
                </FormItem>   
            </Form>
        </div>

        <div v-else>
             <editor
               api-key="5dnl5pqjs8244ysiyhhanjw9fpxt3d8u1oq6921li1hl29tu"
                v-model="mailCommodity.commodityInfo"
                :init="editorInit"   
            />
        </div>
        <div class="bottom-btn">
            <Button v-if="step==1" @click="Save" >保存</Button>
            <Button v-else   @click="step=1" >上一步</Button>
            <Button v-if="step==1" type="primary" style="marginLeft:20px" @click="next">下一步</Button>
             <Button v-else   @click="savaInfo" type="primary" style="marginLeft:20px">保存</Button>
        </div>
         <Modal
            v-model="imageModal"
            title="商品图片"
           >
            <img :src="imageModalUrl" class="big-image"/>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios'
import Editor from '@tinymce/tinymce-vue'
import cropper from '../../child_vue/vue_cropper.vue';

export default {
    components: {Editor, cropper},
    data(){
        return{
            cropper_data:{
                btn_name: '上传图片',
                outputType: 'jpeg',  //生成图片格式
                type:'14',            //图片分组
                vCropper:'6',        //插件分组
                enlarge:"4",         //倍数
                autoCropWidth:"200",
                autoCropHeight:"200"
            }, 
            imageModal:false,
            imageModalUrl:'',
            isEdit:false,
            editorInit:{},
            step:1,//1 第一步 2第二步
            action:'', //上传图片接口地址
            videoAction:'',//上传视频接口地址
            token:'',
            uploadVideoStatus:false,//上传视频状态
            uploadVideoPercent:0,//上传百分比
            spItemImageIndex:0,//商品规格时的索引值
            mailCommodity:{
                name:'',   //商品名
                shareDesc:'',   //分享描述
                commodityCategory:'',   //商品分类
                commodityGroup:'', //商品分组
                freightType:1,//邮费类型 1 统一邮费 2 邮费模板
                freightPrice:0,//邮费价格
                freightTypeGuid:'',//邮费模板的Guid
                sellingPoint:'',//卖点
                images:[],  //商品的图片
                video:null,//商品的视频
                sort:'' ,
                commodityInfo:''   //商品的详情   
            },
            goodsCategory:'',
            goodsGroup:'',
            freightModel:'',//运费模板
            spList:[],
            spcolumns:[
                {
                    title:'* 规格名字' ,
                    key:'specsName'
                },
                {
                    title:'* 价格（元）' ,
                    slot: 'price',
                },
                {
                    title:'* 库存' ,
                    slot: 'stock',
                    
                },
                {
                    title:'重量（KG）',
                    slot: 'weight', 
                },
                {
                    title:'规格编码' ,
                    slot: 'specsCode',
                },
                {
                    title:'孝心值' ,
                    slot: 'integral',
                },
                {
                    title:'显示隐藏' ,
                    slot: 'display',
                },
                {
                    title:'操作' ,
                    width:150,
                    slot: 'operating',
                }
            ],
            SpInputFocus:0
        }
    },
    created(){
        if(this.$route.query.guid!=undefined){ 
            this.isEdit = true
            this.getGoodsInfo(this.$route.query.guid)
        }
        this.getGoodsCategory()
        this.getGoodsGroup()
        this.getFreightModel()
        //设置上传图片的地址
        this.action ="https://api.jiapuji.vip/gateway/attached/service/attached/upload?type=14&guid="+this.$store.state.guid
        this.videoAction = "https://api.jiapuji.vip/gateway/attached/service/attached/upload?type=15&guid="+this.$store.state.guid
        this.token = this.$store.state.token
        
        // TinyMCE 配置
        this.editorInit = {
            language_url: '/tinymce/langs/zh_CN.js',
            language: 'zh_CN',
            skin_url: '/tinymce/skins/ui/oxide',
            content_css: '/tinymce/skins/content/default/content.css',
            height: 500,
            menubar: true,
            promotion: false, // 禁用升级提示
            branding: false, // 移除"Powered by TinyMCE"
            plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
            ],
            toolbar: 'undo redo | formatselect | bold italic backcolor | \
                     alignleft aligncenter alignright alignjustify | \
                     bullist numlist outdent indent | removeformat | image | help',
            images_upload_handler: (blobInfo, success, failure) => {
                const formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                
                axios({
                    url: "https://api.jiapuji.vip/gateway/attached/service/attached/upload?type=14&guid="+this.$store.state.guid,
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.token,
                        'Content-Type': 'multipart/form-data'
                    },
                    data: formData
                }).then(res => {
                    if(res.data.code == 1){
                        this.$Message.success('上传成功！');
                        success(res.data.data.path);
                    } else {
                        this.$Message.error('上传失败！');
                        failure('上传失败');
                    }
                }).catch(err => {
                    console.log(err);
                    this.$Message.error('上传失败！');
                    failure('上传失败');
                });
            }
        }
        
    },
    methods:{
        //获取商品详情
        getGoodsInfo(guid){
            axios({url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/info?guid='+guid})
            .then(res=>{
                if(res.status==200 && res.data.code==1){
                    const goods = res.data.data
                    this.mailCommodity = goods.mailCommodity
                    this.mailCommodity.freightPrice = goods.mailCommodity.freightPrice/100
                    let tempList = [...goods.mailCommodityPrice]
                    console.log(tempList)
                    tempList.map(item=>{
                        item.price = item.price/100
                    }) 
                    this.spList = tempList
                }else{
                    this.$Message.error({
                        background: true,
                        content: '加载失败，请稍后再试'
                    });
                }
            })
        },
        //获取商品品类
        getGoodsCategory(){
            axios({
                url:'https://api.jiapuji.vip/gateway/admin/service/mail/category/get'
            }).then(res=>{
                if(res.status == 200 && res.data.code==1){
                    this.goodsCategory = res.data.data
                }else{
                    this.$Message.error('网络异常');
                }
            })
        },
        //获取商品分类
        getGoodsGroup(){
            axios({
                url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/get'
            }).then(res=>{
                if(res.status == 200 && res.data.code==1){
                    this.goodsGroup = res.data.data
                }else{
                    this.$Message.error('网络异常');
                }
            })
        },
        //获取邮费模板
        getFreightModel(){
            axios({
                url:'https://api.jiapuji.vip/gateway/admin/service/mail/freight/get'
            }).then(res=>{
                if(res.status == 200 && res.data.code==1){
                    this.freightModel = res.data.data
                }else{
                    this.$Message.error('网络异常');
                }
            })
        },
        //商品主图上传回调函数
        GoodsImageHandleSuccess(res){
            if(res.code == 1){
                this.$Message.success('上传成功！');
                this.mailCommodity.images.push(res.data.path)
            }else{
                this.$Message.error('上传失败');
            }
        },
        //删除商品主图
        DelGoodsImage(index){
            this.mailCommodity.images.splice(index,1)
        },
        //商品 视频上传成功回调
        GoodsVideoSuccess(res){
            if(res.code == 1){
                this.$Message.success('上传成功！');
                this.mailCommodity.video=res.data.path
            }else{
                this.$Message.error('上传失败');
            }
        },
        //上传视频时的回调函数
        VideoProgress(e){
            this.uploadVideoPercent=e.percent
            this.uploadVideoStatus = true
            if(e.percent == 100){
                this.$Message.success('上传成功！');
            }
        },
        childFun2(data){
            axios({
                url:this.action,
                method:'POST',
                headers:{
                    'Content-Type':'multipart/form-data'
                },
                data:data.pic_url
            }).then(res=>{
                if(res.status==200&&res.data.code==1){
                    this.$Message.success('上传成功！');
                    this.mailCommodity.images.push(res.data.data.path)
                }else{
                    this.$Message.error('上传失败');
                }
            })
        },
        //选择商品规格时触发
        SpSelect(index){
            this.spItemImageIndex = index
        },
        //商品规格图片上传回调
        handleSuccessSpImage(res){
             if(res.code == 1){
                this.$Message.success('上传成功！');
                this.spList[this.spItemImageIndex].images= [res.data.path]
            }else{
                this.$Message.error('上传失败');
            }
        },
        //添加规格
        AddSp(){
            const spItem={
                specsName:'',
                images:null,
                price:0,
                sort:'',
                integral:0,
                specsCode:'',
                weight:0,
                stock:0,
                isDisplay:0,
                isNew:true
            }
            this.spList.push(spItem)
        },
        //删除规格
        delSp(index){
            this.spList.splice(index,1)
        },
        //编辑规格明细 触发的事件
        spItemFocus(index){
            this.spEditIndex = index
        },
        // 编辑规格 价格input 丢失事件 
        spItemBlur(){
            this.spList[this.spEditIndex].price = parseFloat(this.spList[this.spEditIndex].price).toFixed(2)
            if(this.spList[this.spEditIndex].price<0){
                this.spList[this.spEditIndex].price=0
            }
        },
        //邮费输入框 焦点丢失事件
        freighInputBlur(){
            this.mailCommodity.freightPrice = parseFloat(this.mailCommodity.freightPrice).toFixed(2)
        },
        //改变邮费
        freightChange(){
            if(this.mailCommodity.freightType==1){
                this.mailCommodity.freightTypeGuid=null
            }else{
                this.mailCommodity.freightPrice=null
            }
        },
        //保存
        Save(){
            let mailCommodity =Object.assign({},this.mailCommodity)
            mailCommodity.freightPrice =  mailCommodity.freightPrice*100
            if( mailCommodity.video!=null&&this.mailCommodity.video.indexOf('https://file.jiapuji.vip/gateway/file/files')>-1){
                mailCommodity.video = this.mailCommodity.video.substring(43)
            }
           
            mailCommodity.images=this.mailCommodity.images.map(item=>{
                if(item.indexOf('https://file.jiapuji.vip/gateway/file/files')>-1){
                    return item.substring(43)
                }   
            })
            let spList = [...this.spList]
       
            if(mailCommodity.commodityCategory==''||mailCommodity.commodityGroup==''){
                this.$Message.error('商品分组和商品品类不能为空！！')
            }else if(mailCommodity.name==''){
                this.$Message.error('商品名不能为空！！')
            }else if(mailCommodity.images.length ==0){
                this.$Message.error('商品图片至少有一张')
            }else if(spList.length==0){
                this.$Message.error('至少输入一个规格')
            }else{
                let nameIsNull=false
                spList=spList.map(item=>{
                    if( item.images!=null){
                        item.images[0]= item.images[0].substring(43)
                    }
                    item.price = item.price*100
                    if(item.specsName==''){
                        nameIsNull=true
                    }
                    return item
                })  
                if(nameIsNull){
                    this.$Message.error('规格名字不能为空')
                }else{
                   this.addGoodsFun(mailCommodity,spList)
                   
                    setTimeout(() => {
                        this.$router.push({ path: '/layout/goods/manage'})
                    },1000)
                       
                   
                   
                } 
            }    
        },
        //下一步
        next(){
            let mailCommodity =Object.assign({},this.mailCommodity)
            if( mailCommodity.video!=null&&this.mailCommodity.video.indexOf('https://file.jiapuji.vip/gateway/file/files')>-1){
                mailCommodity.video = this.mailCommodity.video.substring(43)
            }
           
            mailCommodity.images=this.mailCommodity.images.map(item=>{
                if(item.indexOf('https://file.jiapuji.vip/gateway/file/files')>-1){
                    return item.substring(43)
                }   
            })
            let spList = [...this.spList]  
            if(mailCommodity.commodityCategory==''||mailCommodity.commodityGroup==''){
                this.$Message.error('商品分组和商品品类不能为空！！')
            }else if(mailCommodity.name==''){
                this.$Message.error('商品名不能为空！！')
            }else if(mailCommodity.images.length ==0){
                this.$Message.error('商品图片至少有一张')
            }else if(spList.length==0){
                this.$Message.error('至少输入一个规格')
            }else{
                let nameIsNull=false
                spList=spList.map(item=>{
                    if(item.specsName==''){
                        nameIsNull=true
                    }
                    return item
                })  
                if(nameIsNull){
                    this.$Message.error('规格名字不能为空')
                }else{
                    this.step =2
                } 
            }     
        },
        //保存商品详情
        savaInfo(){
            let mailCommodity =Object.assign({},this.mailCommodity)
             mailCommodity.freightPrice =  mailCommodity.freightPrice*100
            if( mailCommodity.video!=null&&this.mailCommodity.video.indexOf('https://file.jiapuji.vip/gateway/file/files')>-1){
                mailCommodity.video = this.mailCommodity.video.substring(43)
            }
           
            mailCommodity.images=this.mailCommodity.images.map(item=>{
                if(item.indexOf('https://file.jiapuji.vip/gateway/file/files')>-1){
                    return item.substring(43)
                }   
            })
            let spList = [...this.spList]
            spList=spList.map(item=>{
                if( item.images!=null){
                    item.images[0]= item.images[0].substring(43)
                }
                item.price = item.price*100
                return item
            })  
            this.addGoodsFun(mailCommodity,spList)
        },
        //添加修改商品的方法
        addGoodsFun(mailCommodity,spList){
            if(this.isEdit){
                //编辑       'null'
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/update?route=/layout/goods/manage/update',
                    method:'PUT',
                    data:{
                        mailCommodity:mailCommodity,
                        mailCommodityPrice:spList
                    }
                }).then(res=>{
                    if(res.status ==200 && res.data.code==1){
                        this.$Message.success('修改成功')
                    }else{
                        this.$Message.error('修改失败')
                    }
                })
                    
            }else{
                //添加
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/add?route=/layout/goods/manage/add',
                    method:'POST',
                    data:{
                        mailCommodity:mailCommodity,
                        mailCommodityPrice:spList
                    }
                }).then(res=>{
                    if(res.status ==200 && res.data.code==1){
                        this.$Message.success('添加成功')
                        this.$router.push({ path: '/layout/goods/manage'})
                    }else{
                        this.$Message.error('添加失败')
                    }
                })
            }
        },
        //展示商品大图
        ShowBigImage(url){
            this.imageModalUrl=url
            this.imageModal=true
        },
        //修改规格 显示延长
        changeSpDisplay(e){
            let displayArry=[]
            this.spList.forEach((item)=>{
                if(item.isDisplay==0){
                    displayArry.push(item)
                }
            })
            if(displayArry.length==0){
                this.$Message.error('至少显示一种规格');
                this.spList[0].isDisplay=0
            }
         
        },
        changeSpFocus(index){
            this.SpInputFocus = index
        },
        del_video(){
             
            this.mailCommodity.video = null;
        },
       
    }
}
</script>

<style scoped>
    .edit{
        padding: 20px;
    }
    .title{
        color: #333;
    }
    .title::before{
        content: '\258D';
        color: #1abc9c;
        font-weight: 900;
        margin-right: 10px;
    }
    .edit-title{
        line-height: 40px;
        color:#333;
        background-color: #F7F7F7;
        padding-left: 20px;
        margin: 5px 0;
    }
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
    .image-view{
        display: flex;
    }
    .image-list{
        display: flex;
    }
    .image-item{
        position: relative;
        width: 110px;
        height: 110px;
        margin-right: 20px;
        
        border: 1px solid #e9e9e9;
    }
    .image-item:hover  .mask{
        display:flex;
    }
    .mask{
        position:absolute;
        top:0;
        left: 0;
        width: 110px;
        height: 110px;
        background-color: rgba(0,0,0,.5);
        display:none;
        align-items: center;
        justify-content: center;
        transition: all .5s;
    }
     .image-item img{
         width: 108px;
         height: 108px;
     }
     .upload{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 110px;
        height: 110px;
        border: 1px dashed #ccc;
     }
     .video-view{
         display: flex;
     }
     .goods-sp{
         display: flex;
        flex-wrap: wrap;
     }
     .sp-item{
         margin-right: 20px;
         margin-bottom: 20px;
         width: 170px;
     }
     .sp-upload{
         display: flex;
         flex-direction: column;
         align-items: center;
         justify-content: center;
        width: 80px;
        height: 80px;
        border: 1px dashed #ccc;
        margin-left: 10px;
     }
     .sp-image-view{
         font-size: 14px;
         display: flex;
         flex-direction: row;
         margin-top: 20px;
     }
    .freight-item{
        display: flex;
     }
     .freight-item span{
        margin-right: 20px;
     }
     .bottom-btn{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background-color: white;
     }
     .big-image{
         width: 500px;
         height: 500px;
         object-fit: contain;
     }
</style>